import ToggleConfig from '../../../config/ToggleConfig';
import filterEventPII from './filterEventPII';
import { Ecdn10Block } from '../../../reporter/report/Report';

export default function filterEcdn10(
  block: Ecdn10Block | undefined,
  toggle: ToggleConfig
): Ecdn10Block | undefined {
  return block
    ? new Ecdn10Block({
        content: block.content,
        agent: block.agent ? filterEventPII(block.agent, toggle) : block.agent
      })
    : block;
}
